import { ColoursObj } from '@eventr/common-storybook'
import { Box, BoxProps } from '@mui/material'

export const AccentBox = (props: BoxProps) => {
    return <Box bgcolor={ColoursObj.backgrounds.secondary} {...props} />
}
